import Vue from "vue";
import AddressInput from "./DataInput/AddressInput";
import AddressAutocompleteInput from "./DataInput/AddressAutocompleteInput";
import BoolInput from "./DataInput/BoolInput";
import DateInput from "./DataInput/DateInput";
import DateDropdownInput from "./DataInput/DateDropdownInput";
import HtmlInput from "./DataInput/HtmlInput";
import ImageInput from "./DataInput/ImageInput";
import ModelInput from "./DataInput/ModelInput";
import NumberInput from "./DataInput/NumberInput";
import SelectInput from "./DataInput/SelectInput";
import TextInput from "./DataInput/TextInput";

export default Vue.extend({
  name: "DataInput",
  functional: true,
  props: {
    type: {
      type: String,
      default: "text"
    }
  },
  render(h, context) {
    function appropriateComponent() {
      const type = context.props.type;

      if (type === "date") return DateInput;
      else if (type === "date-dropdown") return DateDropdownInput;
      else if (type === "address") return AddressInput;
      else if (type === "address-autocomplete") return AddressAutocompleteInput;
      else if (type === "select") return SelectInput;
      else if (type === "number") return NumberInput;
      else if (type === "model") return ModelInput;
      else if (type === "html") return HtmlInput;
      else if (type === "bool") return BoolInput;
      else if (type === "image") return ImageInput;
      else return TextInput;
    }

    context.data.attrs.type = context.props.type;

    return h(appropriateComponent(), context.data, context.children);
  }
});
